export const ONLY_MY_TIMESHEETS_CHECKBOX_TOGGLE =
    'ONLY_MY_TIMESHEETS_CHECKBOX_TOGGLE';
